import { Component, input } from '@angular/core';

export type NavIconName =
  'home' | 'hilfe' | 'marktplatz' | 'verzeichnis' | 'nachrichten' | 'profil' | 'admin';

@Component({
  selector: 'app-nav-icon',
  templateUrl: './nav-icon.component.html',
})
export class NavIconComponent {
  readonly name = input.required<NavIconName>();
  readonly size = input(18);
}
